import React from 'react';
import Box from '@mui/material/Box';
import { MainLayout } from '../components/Layout';
import MessagingPage from '../components/Messaging/MessagingPage';

const Messages = ({ collapsed, setCollapsed }) => {
  return (
    <MainLayout collapsed={collapsed} setCollapsed={setCollapsed}>
      <MessagingPage />
    </MainLayout>
  );
};

export default Messages;
